<app-basic-card [css]="'mb-4'">
    <div class="d-flex justify-content-between align-items-center">
        <img [src]="getCompanyLogo()" alt="company-logo" class="company-logo">
        <div>
            <span class="badge" [ngClass]="getBadgeStyle(policyType)" matTooltip="Tipologia">
                {{ policyType }}
            </span>
            <span class="mx-2">|</span>
            <span class="badge" [ngClass]="getStatusBadgeStyle(policyStatus)" matTooltip="Stato">
                {{ policyStatus }}
            </span>
        </div>
    </div>
    <div class="detail-header-box">
        <ng-container *ngFor="let item of keys">
            <div class="detail-header-item">
                <p class="detail-label">{{ item?.label }}</p>
                <h5>{{ getValueByPath(detail, item) }}</h5>
            </div>
        </ng-container>
        <ng-container *ngFor="let placeholder of getPlaceholders(keys?.length)">
            <div class="detail-header-item"></div>
        </ng-container>
    </div>
    <div class="d-flex justify-content-start mt-4">
        <ng-container *ngIf="showButtons">
            <ng-container *ngIf="showOperationsButton">
                <button mat-raised-button class="btn-info" [matMenuTriggerFor]="operationsMenu">
                    <span class="d-flex align-items-center">
                        {{operationsButtonName | uppercase}}
                        <mat-icon aria-hidden="false" aria-label="drop-down-icon" fontIcon="arrow_drop_down"
                            style="transform: rotate(-90deg);"></mat-icon>
                    </span>
                </button>
                <mat-menu #operationsMenu="matMenu" class="operations-menu">
                    <ng-container *ngFor="let operation of filteredOperations">
                        <button mat-menu-item class="operation-button"
                            (click)="goTo(operation)">{{operation?.operationDesc}}</button>
                    </ng-container>
                </mat-menu>
            </ng-container>
            <button mat-raised-button class="btn-info mx-3" (click)="openTransactionsModal()">{{'operazioni effettuate' | uppercase}}</button>
            <button mat-raised-button class="btn-info" (click)="openPaymentsModal()">{{'quietanze e pagamenti' | uppercase}}</button>
        </ng-container>
        <button mat-button color="primary" [ngClass]="{'mx-3': showButtons}" (click)="goBack()">
            {{'torna indietro' | uppercase}}
        </button>
    </div>
</app-basic-card>
